import React, { forwardRef, useId } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  TextField as MuiTextField,
} from "@mui/material";
import SearchableSelect from "./SearchableSelect";

const SearchableTextField = forwardRef(function SearchableTextField(
  {
    select,
    children,
    SelectProps = {},
    label,
    value,
    defaultValue,
    onChange,
    fullWidth,
    margin,
    variant = "outlined",
    size,
    sx,
    helperText,
    error,
    disabled,
    required,
    id,
    name,
    InputProps,
    InputLabelProps,
    FormHelperTextProps,
    inputProps,
    onBlur,
    onFocus,
    ...props
  },
  ref
) {
  const reactId = useId();
  const valueProps = value !== undefined ? { value } : {};
  const defaultValueProps = defaultValue !== undefined ? { defaultValue } : {};
  const onChangeProps = onChange ? { onChange } : {};

  if (!select) {
    return (
      <MuiTextField
        ref={ref}
        {...props}
        {...valueProps}
        {...defaultValueProps}
        {...onChangeProps}
        label={label}
        fullWidth={fullWidth}
        margin={margin}
        variant={variant}
        size={size}
        sx={sx}
        helperText={helperText}
        error={error}
        disabled={disabled}
        required={required}
        id={id}
        name={name}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
        FormHelperTextProps={FormHelperTextProps}
        inputProps={inputProps}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    );
  }

  const fieldId = id || name || `searchable-text-field-${reactId}`;
  const labelId = `${fieldId}-label`;
  const selectValueProps = value !== undefined ? { value } : { defaultValue };

  return (
    <FormControl
      ref={ref}
      fullWidth={fullWidth}
      margin={margin}
      variant={variant}
      size={size}
      sx={sx}
      error={error}
      disabled={disabled}
      required={required}
    >
      {label ? (
        <InputLabel id={labelId} {...InputLabelProps}>
          {label}
        </InputLabel>
      ) : null}
      <SearchableSelect
        {...SelectProps}
        {...selectValueProps}
        id={fieldId}
        name={name}
        labelId={label ? labelId : undefined}
        label={label}
        onChange={onChange}
        inputProps={inputProps}
        onBlur={onBlur}
        onFocus={onFocus}
      >
        {children}
      </SearchableSelect>
      {helperText ? (
        <FormHelperText {...FormHelperTextProps}>{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  );
});

export default SearchableTextField;
